// eslint-disable-next-line
import React from 'react';
import { sat_national } from './sat_national';
import { createCleanMarkup } from '../utils/common';
import { useContentCMSData } from '../components/digital/common/cmsDataSets';
import ErrorPage from '../components/digital/error/ErrorPage';
import get from 'lodash/get';

const previewContentMissingMessage = 'Preview content missing!';

interface MessagingProps {
  // eslint-disable-next-line
  cmsContentLoaded?: (content: any) => void;
  dynamic?: boolean;
  section?: string;
  preview?: boolean;
  renderPlainText?: boolean;
}

function Messaging({ cmsContentLoaded, dynamic = false, section = '', preview = false }: MessagingProps) {
  // Put the content into state so it doens't keep re-rendering.
  const { cmsData, isLoading } = useContentCMSData(section, preview, cmsContentLoaded);

  if (!dynamic) return sat_national[section as keyof typeof sat_national];

  if (isLoading) return null;

  if (preview) {
    if (!cmsData) return previewContentMissingMessage;

    const content = section && cmsData ? get(cmsData, section, '') : '';
    return <div id='cms-content-wrapper' dangerouslySetInnerHTML={createCleanMarkup(content)} />;
  }

  // Handle dynamic content
  if (cmsData?.section_name) {
    return <div id='cms-content-wrapper' dangerouslySetInnerHTML={createCleanMarkup(cmsData.content || '')} />;
  }

  return (
    <div className='container'>
      <ErrorPage errorCode='cms_missing' />
    </div>
  );
}

export default Messaging;
